/**
 * ScorecardBinder.ts
 *
 * Main entry/controller for the public scorecard view.
 * - DOES NOT require login
 * - Reads `?cardId=...` from the URL
 * - Hides the Round Setup UI
 * - Renders the scorecard into #scorecardContainer
 */
import { showScorecard } from './ShowScorecard';
//import { debug } from '../utils/debug';
//import { traceBlock } from '../utils/trace';
export class ScorecardBinder {
    constructor(repo) {
        this.repo = repo;
    }
    static async create(repo, cardId) {
        const binder = new ScorecardBinder(repo);
        const scope = 'ScorecardBinder.init';
        await binder.init(cardId);
        return binder;
    }
    async init(cardId) {
        try {
            await showScorecard(cardId, this.repo);
        }
        catch (err) {
            console.error(err);
            this.fail(`Error calling ScorecardBinder.showScorecard() for id: ${cardId}`);
        }
    }
    fail(msg) {
        // Prefer a visible message in the scorecard area
        let container = document.getElementById('scorecardContainer');
        if (!container) {
            container = document.createElement('div');
            container.id = 'scorecardContainer';
            document.body.appendChild(container);
        }
        container.innerHTML = `<div style="padding:1rem;color:#a00;font-weight:bold">${msg}</div>`;
    }
}
//# sourceMappingURL=ScorecardBinder.js.map